export default (data, key) => ({
  rel: data[`${key}_rel`] || undefined,
  gtm: {
    event: data[`${key}_gtm_event`] || undefined,
    category: data[`${key}_gtm_category`] || undefined,
    action: data[`${key}_gtm_action`] || undefined,
    label: data[`${key}_gtm_label`] || undefined,
    class: data[`${key}_gtm_class`] || undefined,
  },
});
